import createLucideIcon from '../createLucideIcon';

const Clock7 = createLucideIcon('Clock7', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 9.5 16', key: 'ka3394' }],
]);

export default Clock7;
